import Loadable from 'react-loadable';
import React from 'react';
import Skeleton from '../primitives/skeleton';
import type { JoinableSitesDataProvider } from '../../cross-join/providers/joinable-sites-data-provider';
import type { AtlassianSwitcherProps, CustomizeLinks, GenericShowFlag } from '../../types';
import type { GenericSwitcherProps } from './generic-switcher';

export const loadAtlassianSwitcher = (): Promise<(props: AtlassianSwitcherProps) => JSX.Element> =>
	import(
		/* webpackChunkName: "@ak-switcher-chunk-atlassian-switcher" */ './atlassian-switcher'
	).then((module) => module.default);

export const loadJiraSwitcher = (): Promise<(props: {
    cloudId: string;
    customizeLinks?: CustomizeLinks;
    joinableSitesDataProvider?: JoinableSitesDataProvider;
    product?: string;
    showFlag?: GenericShowFlag<any>;
}) => React.JSX.Element> =>
	import(/* webpackChunkName: "@ak-switcher-chunk-jira-switcher" */ './jira-switcher').then(
		(module) => module.default,
	);

export const loadConfluenceSwitcher = (): Promise<(props: {
    cloudId: string;
    customizeLinks?: CustomizeLinks;
    joinableSitesDataProvider?: JoinableSitesDataProvider;
    showFlag?: GenericShowFlag<any>;
}) => React.JSX.Element> =>
	import(
		/* webpackChunkName: "@ak-switcher-chunk-confluence-switcher" */ './confluence-switcher'
	).then((module) => module.default);

export const loadGenericSwitcher = (): Promise<(props: GenericSwitcherProps) => React.JSX.Element> =>
	import(/* webpackChunkName: "@ak-switcher-chunk-generic-switcher" */ './generic-switcher').then(
		(module) => module.default,
	);

export const AtlassianSwitcherLoader: React.ComponentType<AtlassianSwitcherProps> & Loadable.LoadableComponent = Loadable({
	loader: loadAtlassianSwitcher,
	loading: () => <Skeleton />,
});

export const JiraSwitcherLoader: React.ComponentType<{
    cloudId: string;
    customizeLinks?: CustomizeLinks;
    joinableSitesDataProvider?: JoinableSitesDataProvider;
    product?: string;
    showFlag?: GenericShowFlag<any>;
}> & Loadable.LoadableComponent = Loadable({
	loader: loadJiraSwitcher,
	loading: () => <Skeleton />,
});

export const ConfluenceSwitcherLoader: React.ComponentType<{
    cloudId: string;
    customizeLinks?: CustomizeLinks;
    joinableSitesDataProvider?: JoinableSitesDataProvider;
    showFlag?: GenericShowFlag<any>;
}> & Loadable.LoadableComponent = Loadable({
	loader: loadConfluenceSwitcher,
	loading: () => <Skeleton />,
});

export const GenericSwitcherLoader: React.ComponentType<GenericSwitcherProps> & Loadable.LoadableComponent = Loadable({
	loader: loadGenericSwitcher,
	loading: () => <Skeleton />,
});
